/**
 * My Legal Cases
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const MyLegalCasesState = {
  myLegalCases: {
    legalCases: [],
  },
}

export const MyLegalCasesActions = {
  getMyLegalCases: async ({ commit }, requestData) => {
    commit('setSearchLoading', true)

    return axiosRequest.
      get('/legal_cases/my-cases', { params: requestData.params }).
      then(({ data }) => {
        commit('setMyLegalCases', data || {})
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },
}

export const MyLegalCasesMutations = {
  setMyLegalCases: (state, value) => {
    state.myLegalCases.legalCases = value
  },
}

export const MyLegalCasesGetters = {
  isLoading: state => state.isSearching,
  myLegalCases: state => state.myLegalCases.legalCases,
  paginationOptions: state => state.paginationOptions,
}
